if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.inner = this.querySelector("[data-sticky-atc-inner]");
        this.observeTarget = this.observeTarget.bind(this);
        this.observeTarget();
        document.addEventListener("shopify:section:load", this.observeTarget);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener("shopify:section:load", this.observeTarget);
      }

      observeTarget() {
        this.observer?.disconnect();
        const target = document.querySelector("[data-sticky-atc-target]");
        if (!target) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0) this.hide();
            else if (entry.boundingClientRect.top < 0) this.show();
            else this.hide();
          },
          { threshold: 0.01 },
        );
        this.observer.observe(target);
      }

      show() {
        if (!this.hidden && this.classList.contains("sticky-atc--visible")) return;
        this.hidden = false;
        this.getBoundingClientRect();
        this.classList.add("sticky-atc--visible");
      }

      hide() {
        if (this.hidden) return;
        this.classList.remove("sticky-atc--visible");

        // With no transition (prefers-reduced-motion) transitionend never fires, so hide straight away.
        if (!this.inner || !parseFloat(getComputedStyle(this.inner).transitionDuration)) {
          this.hidden = true;
          return;
        }

        const onEnd = (event) => {
          if (event.propertyName !== "transform") return;
          this.inner.removeEventListener("transitionend", onEnd);
          if (!this.classList.contains("sticky-atc--visible")) this.hidden = true;
        };
        this.inner.addEventListener("transitionend", onEnd);
      }
    },
  );
}
